import React from "react";
import { getConstantStringByLanguage } from "../../templates/helper/getConstantStringByLanguage";
import ConstantStrings from "../../constants/ConstantStrings";

const ServiceItem = ({
  type,
  isMax,
  item,
  index,
  gradeLevel,
  handleSelect,
  isPrek,
}) => {
  // type =1 => 6 tháng
  // type =2 => 12 tháng
  // type =3 => 24 tháng
  var oldPrice = isPrek ? "900.000đ" : "700.000đ";
  var newPrice = isPrek ? "700" : "600";

  var saleStyle = {
    width: "2.25rem",
    height: "2.25rem",
    borderRadius: "1.5rem",
    padding: "0.625rem",
    gap: "0.625rem",
    background: "#EBEFFA",
    color: "#572CD1",
    fontSize: "0.625rem",
    lineHeight: "normal",
    fontStyle: "normal",
    transform: "rotate(-15deg)",
    boxShadow: "0rem 0.0625rem 0rem 0rem #572CD1",
    position: "absolute",
    top: "1.9375rem",
    right: "1.74431rem",
  };
  var sale = "-20";
  // var tag = getConstantStringByLanguage(ConstantStrings.EXPERIENCE);
  if (type === 2) {
    // tag = getConstantStringByLanguage(ConstantStrings.SUGGESTION);
    sale = isPrek ? "-18" : "-21";
    oldPrice = isPrek ? "1.100.000đ" : "1.900.000đ";
    newPrice = isPrek? "900":"1.500";
  } else if (type === 3) {
    // tag = getConstantStringByLanguage(ConstantStrings.SAVE);
    sale = isPrek ? "-21" : "-33";
    oldPrice = isPrek ? "1.900.000đ" : "3.000.000đ";
    newPrice = isPrek ?"1.500":"2.000";
    saleStyle = {...saleStyle, background:"#FED131", color: "#756019"}
  }
  return (
    <div
      className="is-flex is-align-items-center is-clickable is-justify-content-center"
      onClick={() =>
        handleSelect(
          item._id,
          index,
          type === 1
            ? getConstantStringByLanguage(ConstantStrings.PACKAGE_6_MONTH)
            : type === 2
            ? getConstantStringByLanguage(ConstantStrings.PACKAGE_1_YEAR)
            : getConstantStringByLanguage(ConstantStrings.PACKAGE_2_YEAR)
        )
      }
      style={{
        width: "16.5rem",
        borderRadius: "1rem",
        border: "0.0625rem solid #F1EEFC",
        padding: "0.5rem",
        background:
          type === 1
            ? "#FAFBFC"
            : type === 2
            ? "#572CD1"
            : "linear-gradient(180deg, #572CD1 0%, #F3C00E 100%), #572CD1",
        boxShadow: "0rem 0.125rem 0rem 0rem #572CD1",
      }}
    >
      <div
        className={` is-flex is-flex-gap-3 is-flex-direction-column is-align-items-center is-justify-content-end is-flex-grow-1 has-background-kurio-main-color-white is-relative`}
        style={{
          width: "100%",
          height: "7rem",
          borderRadius: "2rem",
          paddingBottom: "0.625rem",
        }}
      >
        <div
          className="is-flex is-align-items-center is-flex-gap-3 is-justify-content-center"
          style={{ width: "100%" }}
        >
          <div className="is-flex is-flex-direction-column is-align-items-center">
            <p
              style={{
                textDecorationLine: "line-through",
                color: "#64779B",
                fontSize: "0.75rem",
                lineHeight: "normal",
                fontStyle: "normal",
                marginBottom: "0.25rem",
              }}
            >
              {oldPrice}
            </p>
            <p
              className="has-text-weight-bold"
              style={{
                fontSize: "2rem",
                lineHeight: "normal",
                fontStyle: "normal",
                marginTop: "-0.5rem",
                color:
                  type === 1 ? "#0A2A66" : type === 2 ? "#572CD1" : "#756019",
              }}
            >
              {newPrice}
              <span
                style={{
                  fontSize: "1.25rem",
                  lineHeight: "normal",
                  fontStyle: "normal",
                }}
              >
                .000đ
              </span>
            </p>
          </div>
        </div>
        <div
          className="is-uppercase has-text-weight-bold is-flex is-align-items-center is-justify-content-center"
          style={saleStyle}
        >
          <p
            style={{
              fontSize: "0.75rem",
              lineHeight: "normal",
              fontStyle: "normal",
            }}
          >
            {sale}<b style={{fontSize:"0.625rem"}}>%</b>
          </p>
        </div>
        <div
          style={{
            padding: "0.5rem 0.75rem",
            borderRadius: "0rem 0rem 1rem 1rem",
            background: type === 2 ? "#DDD5F5" : "#FED131",
            boxShadow: "0rem 0.125rem 0rem 0rem #572CD1",
            color: type === 2 ? "#572CD1" : "#756019",
            position: "absolute",
            top: "-0.4375rem",
            right: "4.28125rem",
            zIndex: 1,
          }}
        >
          <p
            className="is-capitalized has-text-centered"
            style={{
              fontSize: "0.625rem",
              lineHeight: "110%",
              fontWeight: 600,
            }}
          >
            {gradeLevel}
          </p>
          <p
            className="is-uppercase has-text-centered has-text-weight-bold"
            style={{ fontSize: "1rem", lineHeight: "110%" }}
          >
            {type === 2
              ? getConstantStringByLanguage(ConstantStrings.MONTH_12)
              : type === 3
              ? getConstantStringByLanguage(ConstantStrings.MONTH_24)
              : ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceItem;
